import { CheckCircle2, MessageSquareText, Users, Workflow } from "lucide-react";

import { Section, SectionHeading } from "@/components/ui/Section";
import { useLocale } from "@/i18n";
import { cn } from "@/lib/cn";

export function HowItWorks({ heading = true }: { heading?: boolean }) {
  const { t } = useLocale();

  const steps = [
    { icon: MessageSquareText, ...t.how.steps.describe },
    { icon: Users, ...t.how.steps.boardroom },
    { icon: CheckCircle2, ...t.how.steps.approve },
    { icon: Workflow, ...t.how.steps.execute },
  ];

  return (
    <Section id="how-it-works">
      {heading ? (
        <SectionHeading title={t.how.title} subtitle={t.how.subtitle} />
      ) : null}

      <ol className={cn("grid gap-5 sm:grid-cols-2 lg:grid-cols-4", heading && "mt-16")}>
        {steps.map(({ icon: Icon, title, body }, i) => (
          <li key={title} className="card-surface relative flex flex-col p-6">
            <div className="mb-5 flex items-center justify-between">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-500/10 ring-1 ring-emerald-400/20">
                <Icon size={18} className="text-emerald-300" aria-hidden />
              </span>
              {/* Step number is decorative; the list order carries the meaning. */}
              <span
                aria-hidden
                className="tabular text-sm font-medium text-cream-100/25"
              >
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>

            <h3 className="text-lg font-semibold text-cream-50">{title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-cream-100/58">{body}</p>
          </li>
        ))}
      </ol>
    </Section>
  );
}
